import React, { Component } from 'react';
import Routes from './App/routes';

// eslint-disable-next-line react/prefer-stateless-function
export default class App extends Component {
  render() {
    return <Routes />;
  }
}
